// Shared between the Tab styles and the per-entity tab labels so the two-row layout and the
// selected state are driven by the tab's own state instead of prop plumbing.
export const GLOBAL_TAB_LABEL_CLASSES = {
  content: 'global-tab-content',
  overline: 'global-tab-overline',
  main: 'global-tab-main',
  id: 'global-tab-id',
  separator: 'global-tab-separator',
  title: 'global-tab-title',
  unseenBadge: 'global-tab-unseen-badge',
};
